module.exports = __webpack_public_path__ + "static/media/RCP Refund Policy - Footer New.1e9ca5e7.pdf";